import { render } from "./NegativeFeedback.vue?vue&type=template&id=daf7be0c"
import script from "./NegativeFeedback.vue?vue&type=script&lang=js"
export * from "./NegativeFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__